// Tag pills for a help article. Used on article cards (with a limit) and the
// article detail page (full list). Renders nothing when there are no tags.

interface HelpArticleTagsProps {
  tags: string[];
  // Max tags to show; the rest are summarised as "+N"
  limit?: number;
  className?: string;
}

export default function HelpArticleTags({
  tags,
  limit,
  className = '',
}: HelpArticleTagsProps) {
  if (tags.length === 0) return null;

  const visibleTags = limit ? tags.slice(0, limit) : tags;
  const remaining = tags.length - visibleTags.length;

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {visibleTags.map(tag => (
        <span
          key={tag}
          className="inline-block bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 text-xs px-2 py-0.5 rounded-full"
        >
          #{tag}
        </span>
      ))}
      {remaining > 0 && (
        <span className="text-xs text-gray-400 dark:text-gray-500">
          +{remaining}
        </span>
      )}
    </div>
  );
}
